'use strict';
var QualityController = /** @class */ (function () {
    /*@ngInject*/
    function QualityController() {
    }
    return QualityController;
}());
export default QualityController;
//# sourceMappingURL=quality.controller.js.map